(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWpenguin_atlas_", frames: [[0,738,208,208],[210,738,176,176],[587,268,83,146],[217,386,215,350],[0,386,215,350],[0,0,226,384],[0,948,200,70],[434,640,200,70],[388,872,202,132],[388,738,202,132],[228,246,181,132],[336,0,181,132],[434,506,151,132],[434,372,151,132],[592,712,103,119],[592,833,103,119],[519,0,148,132],[503,134,148,132],[228,0,106,244],[411,134,90,236],[434,712,60,24]]}
];


// symbols:



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.PenguinBellyDive_0070002 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.PenguinBelly0001 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.PenguinBelly0002 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.PenguinBody = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.PenguinFeet0001 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.PenguinFeet0002 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0010001 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0010002 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0020001 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0020002 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0030001 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0030002 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0040001 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0040002 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0050001 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.PenguinHead_0050002 = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.PenguinWingBack = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.PenguinWing = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.Tween1dfssd = function() {
	this.spriteSheet = ss["MWpenguin_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.Tween1dfssd_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Tween1dfssd();
	this.instance.parent = this;
	this.instance.setTransform(-15,-6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15,-6,30,12);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.PenguinBellyDive_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.PenguinBellyDive_0070002();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,64.7,78.1);


(lib.penguin_tummyGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("Ajbk9QgkCGgHDUQgHDUBLCNQApBOA2AkQArAdA0ADQBOAEAwgkQAVgPAOgXQAwhMAliOQAkiPgXlZQgWlZk5BRQhmA9glCGg");
	this.shape.setTransform(26.5,59.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.penguin_tummyGlow, new cjs.Rectangle(-1.9,4.4,56.8,109.7), null);


(lib.penguin_footGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AD/grQgphIgDBDQgFgCAAgFQgGgDgsAAQg8AAgEASQgBAFADAMQADAKgDAEQgOAUgQALQgKAHAAAJQAAAjAuAEQAvgCAAABQAAADAAACQAkgBAPgJQALACAVAFQAKADANAAQAjAAAHgTQAAgTAAgBQAAgBgohUgAAAgiQAAgQgJgKQgNgLgigJIhsAAQgVAJg8ADQgxAHAAAiQAAARAJALQARAVAogGQALANAaAKQAYAKATAAQAeAAA+gmQA4gjAAgKg");
	this.shape.setTransform(29.5,8.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.penguin_footGlow, new cjs.Rectangle(-2,-2,63.1,20.2), null);


(lib.penguin_beakGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("ADUgoQgFgIgGgGIgFgEIgigRQgUgHgcgDQg+gGhVAPQgEABgFABIh5AiIgiARQgWAPgBAPQABAAAAAAIAAABQAkgIAdAAQAZAEAhAIQAIACAJACQACABADABIBOAfQAOAFAOAFIAUAIQAJAEAIAEQAHADAGADQAHADAIACQARAEAVgHIAGgCQANgEAPgIQAxgeADgpQAAgNgEgOQgFgLAAAAg");
	this.shape.setTransform(22.1,8.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.penguin_beakGlow, new cjs.Rectangle(-2,-2,48.2,21.5), null);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.blueglowtummy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("Ajbk9QgkCGgHDUQgHDUBLCNQApBOA2AkQArAdA0ADQBOAEAwgkQAVgPAOgXQAwhMAliOQAkiPgXlZQgWlZk5BRQhmA9glCGg");
	this.shape.setTransform(26.5,59.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtummy, new cjs.Rectangle(-1.9,4.4,56.8,109.7), null);


(lib.blueglowfeet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AD/grQgphIgDBDQgFgCAAgFQgGgDgsAAQg8AAgEASQgBAFADAMQADAKgDAEQgOAUgQALQgKAHAAAJQAAAjAuAEQAvgCAAABQAAADAAACQAkgBAPgJQALACAVAFQAKADANAAQAjAAAHgTQAAgTAAgBQAAgBgohUgAAAgiQAAgQgJgKQgNgLgigJIhsAAQgVAJg8ADQgxAHAAAiQAAARAJALQARAVAogGQALANAaAKQAYAKATAAQAeAAA+gmQA4gjAAgKg");
	this.shape.setTransform(29.5,8.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowfeet, new cjs.Rectangle(-2,-2,63.1,20.2), null);


(lib.blueglowbeak = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ADUgoQgFgIgGgGIgFgEIgigRQgUgHgcgDQg+gGhVAPQgEABgFABIh5AiIgiARQgWAPgBAPQABAAAAAAIAAABQAkgIAdAAQAZAEAhAIQAIACAJACQACABADABIBOAfQAOAFAOAFIAUAIQAJAEAIAEQAHADAGADQAHADAIACQARAEAVgHIAGgCQANgEAPgIQAxgeADgpQAAgNgEgOQgFgLAAAAg");
	this.shape.setTransform(22.1,8.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowbeak, new cjs.Rectangle(-2,-2,48.2,21.5), null);


(lib.PenguinWingBack_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.PenguinWingBack();
	this.instance.parent = this;
	this.instance.setTransform(-3,-3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.PenguinWingBack_1, new cjs.Rectangle(-3,-3,53,122), null);


(lib.PenguinWing_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.PenguinWing();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.PenguinWing_1, new cjs.Rectangle(-2,-2,45,118), null);


(lib.PenguinBody_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.PenguinBody();
	this.instance.parent = this;
	this.instance.setTransform(-3,-3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.PenguinBody_1, new cjs.Rectangle(-3,-3,113,192), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.PenguinHead_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:209,glowclean:210,glowclean_loop:211,"final":212,final_loop:213});

	// Layer 2
	this.instance = new lib.PenguinHead_0050001();
	this.instance.parent = this;
	this.instance.setTransform(-19,0,0.5,0.5);

	this.instance_1 = new lib.PenguinHead_0050002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-19,0,0.5,0.5);

	this.instance_2 = new lib.penguin_beakGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-0.3,24.1,1,1,-15.5,0,0,22.1,8.8);

	this.glow = new lib.blueglowbeak();
	this.glow.parent = this;
	this.glow.setTransform(1.4,23.4,1,1,-15,0,0,21.9,8.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1},{t:this.glow}]},204).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-19.5,-0.7,74.8,69);


(lib.PenguinHead_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 2
	this.instance = new lib.PenguinHead_0040001();
	this.instance.parent = this;
	this.instance.setTransform(1,3,0.5,0.5);

	this.instance_1 = new lib.PenguinHead_0040002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(1,3,0.5,0.5);

	this.glow = new lib.blueglowbeak();
	this.glow.parent = this;
	this.glow.setTransform(24.9,28.2,0.484,1.664,0,90,-90,21.9,8.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1},{t:this.glow}]},204).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-7.9,-6.6,63.6,69.6);


(lib.PenguinHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 2
	this.instance = new lib.PenguinHead_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-3,0,0.5,0.5);

	this.instance_1 = new lib.PenguinHead_0030002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-3,0,0.5,0.5);

	this.glow = new lib.blueglowbeak();
	this.glow.parent = this;
	this.glow.setTransform(48.4,21.7,0.8,1.145,0,15,-165,21.8,8.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1},{t:this.glow}]},204).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.4,-0.7,78.3,69);


(lib.PenguinHead_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 2
	this.instance = new lib.PenguinHead_0020001();
	this.instance.parent = this;
	this.instance.setTransform(-3,0,0.5,0.5);

	this.instance_1 = new lib.PenguinHead_0020002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-3,0,0.5,0.5);

	this.glow = new lib.blueglowbeak();
	this.glow.parent = this;
	this.glow.setTransform(57.1,24.2,1.443,1.443,0,0,180,21.9,8.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1},{t:this.glow}]},204).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.4,-0.7,92.5,69);


(lib.PenguinHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,"glowclean":71,"glowclean_loop":72,"final":73,"final_loop":74});

	// Layer 2
	this.instance = new lib.PenguinHead_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-2,0,0.5,0.5);

	this.instance_1 = new lib.PenguinHead_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2,0,0.5,0.5);

	this.instance_2 = new lib.penguin_beakGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(63.8,21.7,1.443,1.443,0,0,180,21.9,8.8);

	this.glow = new lib.blueglowbeak();
	this.glow.parent = this;
	this.glow.setTransform(63.8,21.7,1.443,1.443,0,0,180,21.9,8.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},64).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(140));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.4,-0.7,103,69);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.PenguinFeet_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":79});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(70,13.2,1.013,0.996,0,49.3,55.5,35.4,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(25,22,1.179,1.145,0,8.7,13.7,35.6,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},78).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.PenguinFeet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,"glowclean":71,"glowclean_loop":72,"final":73,"final_loop":74});

	// Layer 5
	this.instance = new lib.PenguinFeet0001();
	this.instance.parent = this;
	this.instance.setTransform(-3,-3,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_few();
	this.instance_1.parent = this;
	this.instance_1.setTransform(69.4,8.8,1,1,0,0,0,47.8,9.3);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(19.7,13.6,0.75,0.75,0,0,0,47.6,10.2);

	this.instance_3 = new lib.PenguinFeet0002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-3,-3,0.5,0.5);

	this.instance_4 = new lib.penguin_footGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(44.3,10.6,1.567,1.567,0,0,180,29.4,8);

	this.glow = new lib.blueglowfeet();
	this.glow.parent = this;
	this.glow.setTransform(44.3,10.6,1.567,1.567,0,0,180,29.4,8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},7).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},57).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(140));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4.1,-3,101.1,35);


(lib.PenguinBelly_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":79});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(35.8,43.6,1.118,1.119,0,121.1,134.6,35.8,10.5);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(61.3,114.6,0.949,1.031,0,-88.7,-82.6,35,11.2);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(73.7,41,1.102,1.105,0,51.4,53.5,35.6,10.8);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(36.7,77.2,1.107,1.128,0,63.9,50.7,35.6,11);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(35.1,106.5,1.107,1.128,0,63.9,50.7,35.4,11.1);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(97.8,79.5,0.949,1.031,0,-88.7,-82.6,35,11.1);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(73.4,70.3,1.127,1.225,0,-88.7,-82.6,35.1,10.9);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(90.1,114.6,0.949,1.031,0,-88.7,-82.6,35,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},78).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.PenguinBelly = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":89,"glowclean":90,"glowclean_loop":91,"final":92,"final_loop":93});

	// Layer 5
	this.instance = new lib.PenguinBelly0001();
	this.instance.parent = this;
	this.instance.setTransform(4,-2,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(59.4,81.7,2,2.2,-90,0,0,50.6,5.2);

	this.instance_2 = new lib.PenguinBelly0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(4,-2,0.5,0.5);

	this.instance_3 = new lib.penguin_tummyGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(58,82.1,2.039,1.592,0,0,0,26.6,59.2);

	this.glow = new lib.blueglowtummy();
	this.glow.parent = this;
	this.glow.setTransform(58,82.1,2.039,1.592,0,0,0,26.6,59.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},7).to({state:[{t:this.instance_2},{t:this.instance_1}]},76).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(121));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(3.9,-2.3,118.4,175.3);


(lib.water_drops_009 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// WET DROPS
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(171.9,1.4,0.486,0.486,0,0,0,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(159,15.9,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(130.1,22,0.486,0.486);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,17,18,23);


(lib.PenguinHead_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":79});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(94.1,22.2,0.561,0.475,0,-154.2,-152.4,36,10.8);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(70,19.6,0.906,0.767,0,19.4,21.2,35.7,10.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(44.8,15,0.906,0.768,0,0.3,-2.8,37.2,10.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},78).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.Penguin = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:25,rest_stop:114,"clean":116,clean_stop:136,wet:138,wet_stop:180,excited:182,excited_stop:290,animalSound:292});

	// timeline functions:
	this.frame_23 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_114 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_136 = function() {
		/* stop();*/
	}
	this.frame_180 = function() {
		/* stop();*/
	}
	this.frame_290 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_332 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(23).call(this.frame_23).wait(91).call(this.frame_114).wait(22).call(this.frame_136).wait(44).call(this.frame_180).wait(110).call(this.frame_290).wait(42).call(this.frame_332).wait(1));

	// Penguin Head_001_bubbles
	this.beak_bubbles = new lib.PenguinHead_001_bubbles();
	this.beak_bubbles.parent = this;
	this.beak_bubbles.setTransform(195.4,158.7,0.469,0.484,0,0,180,26.4,44.8);

	this.timeline.addTween(cjs.Tween.get(this.beak_bubbles).wait(66).to({_off:true},72).wait(195));

	// Penguin Belly_bubbles
	this.tummy_bubbles = new lib.PenguinBelly_bubbles();
	this.tummy_bubbles.parent = this;
	this.tummy_bubbles.setTransform(193.6,223.3,0.323,0.422,0,0,180,53.6,154.1);

	this.timeline.addTween(cjs.Tween.get(this.tummy_bubbles).wait(66).to({_off:true},72).wait(195));

	// Penguin Feet_bubbles
	this.feet_bubbles = new lib.PenguinFeet_bubbles();
	this.feet_bubbles.parent = this;
	this.feet_bubbles.setTransform(190.5,231.9,0.407,0.426,0,0,180,44.1,11.4);

	this.timeline.addTween(cjs.Tween.get(this.feet_bubbles).wait(66).to({_off:true},72).wait(195));

	// Layer 2
	this.instance = new lib.water_drops_009();
	this.instance.parent = this;
	this.instance.setTransform(221.6,211.7,0.465,0.465,0,0,180,92.4,49.2);

	this.instance_1 = new lib.water_drops_009();
	this.instance_1.parent = this;
	this.instance_1.setTransform(164.5,190.3,0.465,0.465,0,0,0,92.4,49.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},138).to({state:[]},44).wait(151));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(177,170.7,0.747,0.747,0,0,180);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(266).to({_off:false},0).to({_off:true},26).wait(41));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(183.4,219.8,0.573,0.573,0,0,180);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(272).to({_off:false},0).to({_off:true},20).wait(41));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(170.6,201.1,0.366,0.366,0,0,180);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(264).to({_off:false},0).to({_off:true},28).wait(41));

	// sparkle
	this.instance_5 = new lib.sparkle();
	this.instance_5.parent = this;
	this.instance_5.setTransform(221.4,178,0.472,0.472,0,0,180);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(258).to({_off:false},0).to({_off:true},34).wait(41));

	// sparkle
	this.instance_6 = new lib.sparkle();
	this.instance_6.parent = this;
	this.instance_6.setTransform(223.2,196.7,0.168,0.168,0,0,180);
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(276).to({_off:false},0).to({_off:true},16).wait(41));

	// sparkle
	this.instance_7 = new lib.sparkle();
	this.instance_7.parent = this;
	this.instance_7.setTransform(189.5,148.8,0.388,0.388,0,0,180);
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(284).to({_off:false},0).to({_off:true},8).wait(41));

	// Penguin Wing
	this.instance_8 = new lib.PenguinWing_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(208.3,165.6,0.471,0.489,0,-3.6,177,31.4,8.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(6).to({regY:8.2,scaleX:0.47,scaleY:0.49,skewX:-7.3,skewY:173.7,x:208.5,y:165.9},0).wait(1).to({regX:31.3,scaleX:0.47,scaleY:0.48,skewX:-11,skewY:170.7,x:208.7,y:166.6},0).wait(9).to({regX:31.4,scaleX:0.47,scaleY:0.49,skewX:-7.3,skewY:173.7,x:208.5,y:165.9},0).wait(1).to({regY:8.7,scaleX:0.47,scaleY:0.49,skewX:-3.6,skewY:177,x:208.3,y:165.6},0).wait(18).to({regY:8.2,scaleY:0.49,skewX:0,skewY:180,x:208.1,y:164.7},0).wait(2).to({regY:8.7,scaleY:0.49,skewX:-3.6,skewY:177,x:208.3,y:165.6},0).wait(2).to({regY:8.2,scaleX:0.47,scaleY:0.49,skewX:-7.3,skewY:173.7,x:208.5,y:165.9},0).wait(2).to({regX:31.3,scaleX:0.47,scaleY:0.48,skewX:-11,skewY:170.7,x:208.7,y:166.6},0).wait(2).to({regX:31.7,scaleX:0.47,scaleY:0.48,skewX:-14.8,skewY:167.5,x:208.9,y:167.1},0).wait(2).to({regX:30.9,scaleX:0.47,scaleY:0.49,skewX:-9.8,skewY:171.7,x:209,y:166.2},0).wait(2).to({regX:31.7,regY:8.3,scaleX:0.47,scaleY:0.49,skewX:-4.8,skewY:176,x:208.4,y:165.5},0).wait(2).to({regX:31.4,regY:8.2,scaleX:0.47,scaleY:0.49,skewX:0,skewY:180,x:208.1,y:164.7},0).wait(22).to({regX:31.7,regY:8.3,scaleX:0.47,scaleY:0.49,skewX:-4.8,skewY:176,x:208.4,y:165.5},0).wait(2).to({regX:30.9,regY:8.2,scaleX:0.47,scaleY:0.49,skewX:-9.8,skewY:171.7,x:209,y:166.2},0).wait(2).to({regX:31.7,scaleX:0.47,scaleY:0.48,skewX:-14.8,skewY:167.5,x:208.9,y:167.1},0).wait(2).to({regX:31.3,scaleX:0.47,scaleY:0.48,skewX:-11,skewY:170.7,x:208.7,y:166.6},0).wait(2).to({regX:31.4,scaleX:0.47,scaleY:0.49,skewX:-7.3,skewY:173.7,x:208.5,y:165.9},0).wait(2).to({regY:8.7,scaleX:0.47,scaleY:0.49,skewX:-3.6,skewY:177,x:208.3,y:165.6},0).wait(111).to({regX:33.4,regY:3.5,scaleY:0.49,skewX:0,skewY:180,x:207.2,y:162.3},0).wait(2).to({y:164.3},0).wait(2).to({y:168},0).wait(2).to({y:171.7},0).wait(2).to({regY:3.4,skewX:-6.2,skewY:173.8,x:199.4,y:163.9},0).wait(2).to({regY:3.2,scaleX:0.47,scaleY:0.51,skewX:-12.4,skewY:166.5,x:191.1,y:159},0).wait(2).to({regX:33.2,regY:3.1,scaleX:0.48,scaleY:0.52,skewX:-9.3,skewY:166.4,x:195.4,y:148},0).wait(2).to({regY:3.2,scaleX:0.49,scaleY:0.54,skewX:-6.4,skewY:166,x:199.7,y:137.2},0).wait(2).to({regX:33.1,scaleX:0.49,scaleY:0.53,skewX:-4.8,skewY:169.5,x:201.7,y:145.8},0).wait(2).to({regX:33.2,scaleX:0.48,scaleY:0.51,skewX:-3.1,skewY:173,x:203.4,y:154.5},0).wait(2).to({scaleX:0.48,scaleY:0.5,skewX:-1.5,skewY:176.5,x:205.3,y:163.1},0).wait(2).to({regX:33.4,regY:3.5,scaleX:0.47,scaleY:0.49,skewX:0,skewY:180,x:207.2,y:171.7},0).wait(2).to({y:168},0).wait(2).to({y:162.3},0).wait(2).to({regX:31.4,regY:8.7,scaleY:0.49,skewX:-3.6,skewY:177,x:208.3,y:165.6},0).wait(2).to({regY:8.3,skewX:-18.6,skewY:162,y:165.4},0).wait(2).to({regX:33.1,regY:1.8,scaleY:0.49,rotation:9.2,skewX:0,skewY:0,x:184.5,y:161.5},0).wait(2).to({regX:33.2,scaleX:0.47,rotation:6,y:165},0).wait(2).to({regX:33.1,regY:1.9,scaleX:0.47,rotation:3,y:168.4},0).wait(2).to({regX:33.4,regY:3.5,rotation:0,y:171.7},0).wait(2).to({regY:3.4,rotation:6.2,x:192.4,y:163.9},0).wait(2).to({regY:3.2,scaleX:0.47,scaleY:0.51,rotation:0,skewX:12.4,skewY:13.5,x:200.6,y:159},0).wait(2).to({regX:33.2,scaleX:0.48,scaleY:0.52,skewX:9.3,skewY:13.6,x:196.3,y:148.1},0).wait(2).to({scaleX:0.49,scaleY:0.54,skewX:6.4,skewY:14,x:192.1,y:137.2},0).wait(2).to({regY:3.7,scaleX:0.49,scaleY:0.53,skewX:4.8,skewY:10.5,x:190.2,y:146.1},0).wait(2).to({regY:3.2,scaleX:0.48,scaleY:0.51,skewX:3.1,skewY:7,x:188.3,y:154.5},0).wait(2).to({regY:3.1,scaleX:0.48,scaleY:0.5,skewX:1.5,skewY:3.5,x:186.5,y:163.1},0).wait(2).to({regX:33.4,regY:3.5,scaleX:0.47,scaleY:0.49,skewX:0,skewY:0,x:184.5,y:171.7},0).wait(2).to({y:168},0).wait(2).to({y:162.3},0).wait(2).to({regX:31.4,regY:8.7,scaleY:0.49,skewX:3.6,skewY:3,x:183.4,y:165.6},0).wait(81));

	// Penguin Belly
	this.penguin_torso = new lib.PenguinBelly();
	this.penguin_torso.parent = this;
	this.penguin_torso.setTransform(193.6,223.3,0.323,0.422,0,0,180,53.6,154.1);

	this.penguin_torso_1 = new lib.PenguinBellyDive_007();
	this.penguin_torso_1.parent = this;
	this.penguin_torso_1.setTransform(182,168.9,1,1,0,20.5,-159.5,22.4,37.6);
	this.penguin_torso_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.penguin_torso).wait(6).to({regY:154.2,scaleX:0.33,scaleY:0.42,x:193.8,y:223.5},0).wait(1).to({scaleX:0.33,scaleY:0.42,x:193.9,y:223.7},0).wait(9).to({scaleX:0.33,scaleY:0.42,x:193.8,y:223.5},0).wait(1).to({regY:154.1,scaleX:0.32,scaleY:0.42,x:193.6,y:223.3},0).wait(18).to({regY:154.2,scaleX:0.32,scaleY:0.43,x:193.5,y:223.2},0).wait(2).to({regY:154.1,scaleX:0.32,scaleY:0.42,x:193.6,y:223.3},0).wait(2).to({regY:154.2,scaleX:0.33,scaleY:0.42,x:193.8,y:223.5},0).wait(2).to({scaleX:0.33,scaleY:0.42,x:193.9,y:223.7},0).wait(2).to({regY:154.3,scaleX:0.33,scaleY:0.41,x:194,y:223.8},0).wait(2).to({regX:53.4,scaleX:0.33,scaleY:0.42,x:193.9,y:223.6},0).wait(2).to({regX:53.6,scaleX:0.32,scaleY:0.42,x:193.7,y:223.4},0).wait(2).to({regY:154.2,scaleX:0.32,scaleY:0.43,x:193.5,y:223.2},0).wait(22).to({regY:154.3,scaleX:0.32,scaleY:0.42,x:193.7,y:223.4},0).wait(2).to({regX:53.4,scaleX:0.33,scaleY:0.42,x:193.9,y:223.6},0).wait(2).to({regX:53.6,scaleX:0.33,scaleY:0.41,x:194,y:223.8},0).wait(2).to({regY:154.2,scaleX:0.33,scaleY:0.42,x:193.9,y:223.7},0).wait(2).to({scaleX:0.33,scaleY:0.42,x:193.8,y:223.5},0).wait(2).to({regY:154.1,scaleX:0.32,scaleY:0.42,x:193.6,y:223.3},0).wait(111).to({regX:47.4,regY:85.7,scaleX:0.32,scaleY:0.43,x:195.5,y:194},0).wait(2).to({regX:47.3,scaleX:0.33,scaleY:0.4,x:195.1,y:196.9},0).wait(2).to({regX:47.4,scaleX:0.34,scaleY:0.37,x:194.7,y:199.7},0).wait(2).to({regY:85.6,scaleX:0.34,scaleY:0.34,x:194.3,y:202.6},0).wait(2).to({regY:85.7,scaleX:0.32,scaleY:0.39,skewX:-6.2,skewY:173.8,x:191.1,y:196.3},0).wait(2).to({regX:47.2,regY:85.8,scaleY:0.42,skewX:-12.8,skewY:165.9,x:186.1,y:192.5},0).wait(2).to({regX:46.8,scaleX:0.3,scaleY:0.39,skewX:-7.5,skewY:168.1,x:185.3,y:180.1},0).to({_off:true},2).wait(8).to({_off:false,regX:47.4,regY:85.6,scaleX:0.34,scaleY:0.34,skewX:0,skewY:180,x:194.3,y:202.6},0).wait(2).to({regY:85.7,scaleX:0.34,scaleY:0.37,x:194.7,y:199.7},0).wait(2).to({scaleX:0.32,scaleY:0.43,x:195.5,y:194},0).wait(2).to({regX:53.6,regY:154.1,scaleX:0.32,scaleY:0.42,x:193.6,y:223.3},0).wait(2).to({x:194.7},0).wait(2).to({regX:47.4,regY:85.7,scaleX:0.32,scaleY:0.43,skewY:0,x:196.2,y:194},0).wait(2).to({regX:47.3,scaleX:0.33,scaleY:0.4,x:196.6,y:196.9},0).wait(2).to({regX:47.4,scaleX:0.34,scaleY:0.37,x:197,y:199.7},0).wait(2).to({regY:85.6,scaleX:0.34,scaleY:0.34,x:197.4,y:202.6},0).wait(2).to({regY:85.7,scaleX:0.32,scaleY:0.39,rotation:6.2,x:200.6,y:196.3},0).wait(2).to({regX:47.2,regY:85.8,scaleY:0.42,rotation:0,skewX:12.8,skewY:14.1,x:205.7,y:192.5},0).wait(2).to({regX:46.8,regY:85,scaleX:0.3,scaleY:0.39,skewX:7.5,skewY:11.9,x:206.5,y:179.8},0).to({_off:true},2).wait(8).to({_off:false,regX:47.4,regY:85.6,scaleX:0.34,scaleY:0.34,skewX:0,skewY:0,x:197.4,y:202.6},0).wait(2).to({regY:85.7,scaleX:0.34,scaleY:0.37,x:197,y:199.7},0).wait(2).to({scaleX:0.32,scaleY:0.43,x:196.2,y:194},0).wait(2).to({regX:53.6,regY:154.1,scaleX:0.32,scaleY:0.42,x:198.1,y:223.3},0).wait(81));
	this.timeline.addTween(cjs.Tween.get(this.penguin_torso_1).wait(206).to({_off:false},0).wait(2).to({scaleX:1,scaleY:0.92,skewX:22.5,x:184.3,y:177.7},0).wait(2).to({scaleY:0.84,skewX:24.5,x:186.6,y:186.3},0).wait(2).to({regX:22.3,regY:37.5,scaleX:1,scaleY:0.76,skewX:26.6,x:188.8,y:195},0).to({_off:true},2).wait(24).to({_off:false,regX:22.4,regY:37.6,scaleY:1,rotation:-20.5,skewX:0,skewY:0,x:209.8,y:168.9},0).wait(2).to({regY:37.7,scaleX:1,scaleY:0.92,rotation:0,skewX:-22.5,skewY:-20.5,x:207.6,y:177.8},0).wait(2).to({regY:37.6,scaleY:0.84,skewX:-24.5,x:205.2,y:186.3},0).wait(2).to({regX:22.3,regY:37.5,scaleX:1,scaleY:0.76,skewX:-26.6,x:203,y:195},0).to({_off:true},2).wait(87));

	// Penguin Head
	this.penguin_head = new lib.PenguinHead_001();
	this.penguin_head.parent = this;
	this.penguin_head.setTransform(195.4,158.7,0.469,0.484,0,0,180,26.4,44.8);

	this.penguin_head_1 = new lib.PenguinHead_002();
	this.penguin_head_1.parent = this;
	this.penguin_head_1.setTransform(195.4,158.7,0.469,0.484,0,0,180,26.4,44.8);
	this.penguin_head_1._off = true;

	this.penguin_head_2 = new lib.PenguinHead_003();
	this.penguin_head_2.parent = this;
	this.penguin_head_2.setTransform(195.4,159.3,0.471,0.48,0,0,180,26.6,44.7);
	this.penguin_head_2._off = true;

	this.penguin_head_3 = new lib.PenguinHead_004();
	this.penguin_head_3.parent = this;
	this.penguin_head_3.setTransform(195.6,160,0.473,0.476,0,0,180,26.4,44.6);

	this.penguin_head_4 = new lib.PenguinHead_005();
	this.penguin_head_4.parent = this;
	this.penguin_head_4.setTransform(195.7,160.6,0.475,0.472,0,0,180,26.6,44.7);
	this.penguin_head_4._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.penguin_head}]}).to({state:[{t:this.penguin_head_1}]},4).to({state:[{t:this.penguin_head_2}]},2).to({state:[{t:this.penguin_head_3,p:{regY:44.6,scaleX:0.473,scaleY:0.476,x:195.6,y:160}}]},1).to({state:[{t:this.penguin_head_2}]},9).to({state:[{t:this.penguin_head_1}]},1).to({state:[{t:this.penguin_head}]},1).to({state:[{t:this.penguin_head}]},7).to({state:[{t:this.penguin_head}]},10).to({state:[{t:this.penguin_head_1}]},2).to({state:[{t:this.penguin_head_2}]},2).to({state:[{t:this.penguin_head_3,p:{regY:44.6,scaleX:0.473,scaleY:0.476,x:195.6,y:160}}]},2).to({state:[{t:this.penguin_head_4}]},2).to({state:[{t:this.penguin_head_4}]},2).to({state:[{t:this.penguin_head_4}]},2).to({state:[{t:this.penguin_head_4}]},2).to({state:[{t:this.penguin_head_4}]},17).to({state:[{t:this.penguin_head_4}]},3).to({state:[{t:this.penguin_head_4}]},2).to({state:[{t:this.penguin_head_4}]},2).to({state:[{t:this.penguin_head_4}]},2).to({state:[{t:this.penguin_head_3,p:{regY:44.6,scaleX:0.473,scaleY:0.476,x:195.6,y:160}}]},2).to({state:[{t:this.penguin_head_2}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},33).to({state:[{t:this.penguin_head}]},22).to({state:[{t:this.penguin_head}]},46).to({state:[{t:this.penguin_head_1}]},10).to({state:[{t:this.penguin_head_1}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head_1}]},2).to({state:[{t:this.penguin_head_2}]},2).to({state:[{t:this.penguin_head_3,p:{regY:44.8,scaleX:0.469,scaleY:0.484,x:195.4,y:158.7}}]},2).to({state:[{t:this.penguin_head_2}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head}]},2).to({state:[{t:this.penguin_head_1}]},2).to({state:[{t:this.penguin_head_1}]},2).wait(81));
	this.timeline.addTween(cjs.Tween.get(this.penguin_head).to({_off:true},4).wait(14).to({_off:false},0).wait(17).to({regY:44.7,scaleX:0.47,scaleY:0.49,x:195.3,y:157.9},0).to({_off:true},2).wait(44).to({_off:false,regY:44.8,scaleX:0.47,scaleY:0.48,x:195.4,y:158.7},0).wait(101).to({_off:true},10).wait(4).to({_off:false,regX:27.9,regY:48,scaleX:0.47,scaleY:0.49,skewX:-2.9,skewY:176.2,x:194.4,y:167.5},0).wait(2).to({regX:27.8,skewX:-8.2,skewY:171.8,x:194.6,y:172.5},0).wait(2).to({regX:27.9,regY:47.9,skewX:-14.5,skewY:165.5,x:186.9,y:166},0).wait(2).to({regX:27.7,regY:47.8,scaleX:0.47,scaleY:0.53,skewX:-20.4,skewY:157,x:177.8,y:160.2},0).wait(2).to({regX:27.8,scaleX:0.48,scaleY:0.53,skewX:-7,skewY:171.2,x:182.1,y:149.5},0).wait(2).to({regX:27.2,regY:49.5,scaleX:0.49,scaleY:0.53,skewX:6.2,skewY:185,x:186.5,y:138.9},0).wait(2).to({regX:27.3,scaleX:0.49,scaleY:0.52,skewX:2.5,skewY:181.6,x:188.6,y:147.3},0).wait(2).to({regX:27.2,scaleX:0.48,scaleY:0.51,skewX:-0.8,skewY:178.5,x:190.6,y:155.6},0).wait(2).to({regX:27.3,regY:49.6,scaleX:0.47,scaleY:0.5,skewX:-4.5,skewY:175.2,x:192.6,y:164.2},0).wait(2).to({regX:27.8,regY:48,scaleX:0.47,scaleY:0.49,skewX:-8.2,skewY:171.8,x:194.6,y:172.5},0).wait(2).to({regX:27.9,skewX:-2.9,skewY:176.2,x:194.4,y:167.5},0).to({_off:true},2).wait(8).to({_off:false,regX:27.8,regY:47.9,skewX:0,skewY:0,x:197.1,y:163.5},0).wait(2).to({regX:27.9,regY:48,skewX:2.9,skewY:3.8,x:197.4,y:167.5},0).wait(2).to({regX:26.7,regY:47.7,rotation:8.2,skewX:0,skewY:0,x:196.6,y:172.3},0).wait(2).to({regX:27.8,regY:47.9,rotation:14.5,x:204.8,y:166},0).wait(2).to({regX:27.7,regY:47.8,scaleX:0.47,scaleY:0.53,rotation:0,skewX:20.4,skewY:23,x:213.9,y:160.2},0).wait(2).to({regX:27.8,scaleX:0.48,scaleY:0.53,skewX:7,skewY:8.8,x:209.4,y:149.3},0).wait(2).to({regX:26.7,regY:48.5,scaleX:0.49,scaleY:0.53,skewX:-6.2,skewY:-5,x:204.9,y:138.4},0).wait(2).to({regX:26.6,scaleX:0.49,scaleY:0.52,skewX:-2.5,skewY:-1.6,x:202.8,y:146.9},0).wait(2).to({regX:26.7,regY:48.6,scaleX:0.48,scaleY:0.51,skewX:0.8,skewY:1.5,x:200.7,y:155.4},0).wait(2).to({regX:26.4,scaleX:0.47,scaleY:0.5,skewX:4.5,skewY:4.8,x:198.5,y:163.9},0).wait(2).to({regX:26.7,regY:47.7,scaleX:0.47,scaleY:0.49,rotation:8.2,skewX:0,skewY:0,x:196.6,y:172.3},0).wait(2).to({regX:27.9,regY:48,rotation:0,skewX:2.9,skewY:3.8,x:197.4,y:167.5},0).to({_off:true},2).wait(83));
	this.timeline.addTween(cjs.Tween.get(this.penguin_head_1).wait(4).to({_off:false},0).to({_off:true},2).wait(11).to({_off:false},0).to({_off:true},1).wait(19).to({_off:false},0).to({_off:true},2).wait(153).to({_off:false,regX:27.8,regY:47.9,scaleX:0.47,scaleY:0.49,x:194.7,y:159.5},0).wait(2).to({y:163.5},0).to({_off:true},2).wait(22).to({_off:false,y:159.5},0).to({_off:true},2).wait(30).to({_off:false,skewY:0,x:197.1},0).wait(2).to({regX:26.4,regY:44.8,scaleX:0.47,scaleY:0.48,x:196.3,y:158.7},0).wait(81));
	this.timeline.addTween(cjs.Tween.get(this.penguin_head_2).wait(6).to({_off:false},0).to({_off:true},1).wait(9).to({_off:false},0).to({_off:true},1).wait(22).to({_off:false},0).to({_off:true},2).wait(38).to({_off:false},0).to({_off:true},2).wait(139).to({_off:false,regX:26.4,regY:44.8,scaleX:0.47,scaleY:0.48,y:158.7},0).to({_off:true},2).wait(2).to({_off:false,regX:27.8,regY:47.9,scaleX:0.47,scaleY:0.49,skewY:0,x:197.1,y:159.5},0).to({_off:true},2).wait(107));
	this.timeline.addTween(cjs.Tween.get(this.penguin_head_4).wait(43).to({_off:false},0).wait(2).to({x:195.2,y:159.6},0).wait(2).to({x:194.7,y:158.6},0).wait(2).to({x:194.3,y:157.6},0).wait(22).to({x:194.7,y:158.6},0).wait(2).to({x:195.2,y:159.6},0).wait(2).to({x:195.7,y:160.6},0).to({_off:true},2).wait(256));

	// Penguin Body
	this.instance_9 = new lib.PenguinBody_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(200.1,224,0.361,0.422,0,0,180,40.1,165.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(6).to({regX:40.2,regY:165.6,scaleX:0.36,scaleY:0.42,x:200.2,y:224.1},0).wait(1).to({regX:40.1,regY:165.8,scaleX:0.36,scaleY:0.42,x:200.4,y:224.2},0).wait(9).to({regX:40.2,regY:165.6,scaleX:0.36,scaleY:0.42,x:200.2,y:224.1},0).wait(1).to({regX:40.1,regY:165.7,scaleX:0.36,scaleY:0.42,x:200.1,y:224},0).wait(18).to({scaleX:0.36,scaleY:0.43,x:199.9,y:223.8},0).wait(2).to({scaleX:0.36,scaleY:0.42,x:200.1,y:224},0).wait(2).to({regX:40.2,regY:165.6,scaleX:0.36,scaleY:0.42,x:200.2,y:224.1},0).wait(2).to({regX:40.1,regY:165.8,scaleX:0.36,scaleY:0.42,x:200.4,y:224.2},0).wait(2).to({regY:165.6,scaleX:0.37,scaleY:0.41,x:200.5,y:224.4},0).wait(2).to({regY:165.7,scaleX:0.36,scaleY:0.42,x:200.3,y:224.2},0).wait(2).to({regX:40,regY:165.6,scaleX:0.36,scaleY:0.42,x:200.1,y:224},0).wait(2).to({regX:40.1,regY:165.7,scaleX:0.36,scaleY:0.43,x:199.9,y:223.8},0).wait(22).to({regX:40,regY:165.6,scaleX:0.36,scaleY:0.42,x:200.1,y:224},0).wait(2).to({regX:40.1,regY:165.7,scaleX:0.36,scaleY:0.42,x:200.3,y:224.2},0).wait(2).to({regY:165.6,scaleX:0.37,scaleY:0.41,x:200.5,y:224.4},0).wait(2).to({regY:165.8,scaleX:0.36,scaleY:0.42,x:200.4,y:224.2},0).wait(2).to({regX:40.2,regY:165.6,scaleX:0.36,scaleY:0.42,x:200.2,y:224.1},0).wait(2).to({regX:40.1,regY:165.7,scaleX:0.36,scaleY:0.42,x:200.1,y:224},0).wait(111).to({regX:50.6,regY:89.7,scaleX:0.36,scaleY:0.43,x:196.2,y:191.5},0).wait(2).to({scaleX:0.37,scaleY:0.4,x:195.8,y:194.5},0).wait(2).to({regY:89.8,scaleX:0.39,scaleY:0.37,x:195.4,y:197.7},0).wait(2).to({regY:89.7,scaleX:0.41,scaleY:0.35,x:195,y:200.8},0).wait(2).to({regX:49.6,scaleX:0.36,scaleY:0.43,skewX:-6.2,skewY:173.8,x:191.9,y:194},0).wait(2).to({regX:50.9,regY:90.3,scaleY:0.46,skewX:-12.8,skewY:165.9,x:186.1,y:190.2},0).wait(2).to({regX:51,scaleX:0.37,scaleY:0.46,skewX:-5.5,skewY:173.5,x:186.6,y:179.5},0).wait(2).to({regX:50.5,regY:89.9,scaleX:0.38,scaleY:0.46,skewX:1.7,skewY:181,x:187.1,y:168.7},0).wait(2).to({regY:89.8,scaleX:0.38,scaleY:0.43,skewX:1.3,skewY:180.6,x:189.1,y:176.7},0).wait(2).to({regY:89.9,scaleX:0.39,scaleY:0.4,skewX:0.8,skewY:180.3,x:191,y:184.7},0).wait(2).to({regX:50.2,regY:90.1,scaleX:0.4,scaleY:0.38,skewX:0.3,skewY:180.1,x:193.2,y:192.9},0).wait(2).to({regX:50.6,regY:89.7,scaleX:0.41,scaleY:0.35,skewX:0,skewY:180,x:195,y:200.8},0).wait(2).to({regY:89.8,scaleX:0.39,scaleY:0.37,x:195.4,y:197.7},0).wait(2).to({regY:89.7,scaleX:0.36,scaleY:0.43,x:196.2,y:191.5},0).wait(2).to({regX:40.1,regY:165.7,scaleX:0.36,scaleY:0.42,x:200.1,y:224},0).wait(4).to({regX:50.6,regY:89.7,scaleX:0.36,scaleY:0.43,skewY:0,x:195.6,y:191.5},0).wait(2).to({scaleX:0.37,scaleY:0.4,x:196,y:194.5},0).wait(2).to({regY:89.8,scaleX:0.39,scaleY:0.37,x:196.3,y:197.7},0).wait(2).to({regY:89.7,scaleX:0.41,scaleY:0.35,x:196.7,y:200.8},0).wait(2).to({regX:49.6,scaleX:0.36,scaleY:0.43,rotation:6.2,x:199.8,y:194},0).wait(2).to({regX:50.9,regY:90.3,scaleY:0.46,rotation:0,skewX:12.8,skewY:14.1,x:205.6,y:190.2},0).wait(2).to({regX:51,scaleX:0.37,scaleY:0.46,skewX:5.5,skewY:6.5,x:205.1,y:179.5},0).wait(2).to({regX:50.5,regY:89.7,scaleX:0.38,scaleY:0.46,skewX:-1.7,skewY:-1,x:204.6,y:168.6},0).wait(2).to({regY:89.8,scaleX:0.38,scaleY:0.43,skewX:-1.3,skewY:-0.6,x:202.6,y:176.7},0).wait(2).to({regY:89.7,scaleX:0.39,scaleY:0.4,skewX:-0.8,skewY:-0.3,x:200.8,y:184.7},0).wait(2).to({regX:50.2,regY:89.5,scaleX:0.4,scaleY:0.38,skewX:-0.3,skewY:-0.1,x:198.5,y:192.7},0).wait(2).to({regX:50.6,regY:89.7,scaleX:0.41,scaleY:0.35,skewX:0,skewY:0,x:196.7,y:200.8},0).wait(2).to({regY:89.8,scaleX:0.39,scaleY:0.37,x:196.3,y:197.7},0).wait(2).to({regY:89.7,scaleX:0.36,scaleY:0.43,x:195.6,y:191.5},0).wait(2).to({regX:40.1,regY:165.7,scaleX:0.36,scaleY:0.42,x:191.6,y:224},0).wait(81));

	// Penguin Feet
	this.penguin_foot = new lib.PenguinFeet();
	this.penguin_foot.parent = this;
	this.penguin_foot.setTransform(190.5,231.9,0.407,0.426,0,0,180,44.1,11.4);

	this.penguin_foot_1 = new lib.Tween1dfssd_1();
	this.penguin_foot_1.parent = this;
	this.penguin_foot_1.setTransform(194.8,230.4,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.penguin_foot}]}).to({state:[{t:this.penguin_foot}]},4).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},1).to({state:[{t:this.penguin_foot}]},9).to({state:[{t:this.penguin_foot}]},1).to({state:[{t:this.penguin_foot}]},1).to({state:[{t:this.penguin_foot}]},7).to({state:[{t:this.penguin_foot}]},10).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},17).to({state:[{t:this.penguin_foot}]},3).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},33).to({state:[{t:this.penguin_foot}]},22).to({state:[{t:this.penguin_foot}]},46).to({state:[{t:this.penguin_foot}]},10).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot_1}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).to({state:[{t:this.penguin_foot}]},2).wait(81));
	this.timeline.addTween(cjs.Tween.get(this.penguin_foot).wait(204).to({regX:43.9,regY:11.5,scaleX:0.36,scaleY:0.54,skewX:8.3,skewY:188.3,x:186.5,y:219.7},0).wait(2).to({regX:48.6,regY:5.4,scaleX:0.3,scaleY:0.66,skewX:16.8,skewY:196.8,x:182.6,y:207.4},0).wait(2).to({regY:5.9,scaleX:0.33,scaleY:0.6,skewX:12.5,skewY:192.5,x:184.5,y:213.9},0).wait(2).to({regX:48.7,regY:5.2,scaleX:0.36,scaleY:0.54,skewX:8.3,skewY:188.3,x:186.5,y:219.6},0).wait(2).to({regX:48.6,regY:6,scaleX:0.38,scaleY:0.49,skewX:4.1,skewY:184.1,x:188.5,y:226.1},0).wait(2).to({regX:44.1,regY:11.4,scaleX:0.41,scaleY:0.43,skewX:0,skewY:180,x:190.5,y:231.9},0).wait(6).to({_off:true},2).wait(2).to({_off:false,skewY:0,x:201.3},0).wait(12).to({regX:43.9,regY:11.3,scaleX:0.36,scaleY:0.54,rotation:-8.3,x:205.2,y:219.8},0).wait(2).to({regX:48.4,regY:5.8,scaleX:0.3,scaleY:0.66,rotation:-16.8,x:209.2,y:207.6},0).wait(2).to({regX:48.2,scaleX:0.33,scaleY:0.6,rotation:-12.5,x:207.1,y:213.7},0).wait(2).to({regX:48.5,scaleX:0.36,scaleY:0.54,rotation:-8.3,x:205.2,y:219.8},0).wait(2).to({scaleX:0.38,scaleY:0.49,rotation:-4.1,x:203.3,y:225.9},0).wait(2).to({regX:44.1,regY:11.4,scaleX:0.41,scaleY:0.43,rotation:0,x:201.3,y:231.9},0).wait(87));

	// Penguin Wing Back
	this.instance_10 = new lib.PenguinWingBack_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(183.4,165.5,0.443,0.46,0,3.8,-177,8.4,8.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(6).to({scaleX:0.44,scaleY:0.46,skewX:7.5,skewY:-173.7,x:183.5,y:166.1},0).wait(1).to({regX:8.6,scaleX:0.45,scaleY:0.46,skewX:11.3,skewY:-170.7,y:166.7},0).wait(9).to({regX:8.4,scaleX:0.44,scaleY:0.46,skewX:7.5,skewY:-173.7,y:166.1},0).wait(1).to({scaleX:0.44,scaleY:0.46,skewX:3.8,skewY:-177,x:183.4,y:165.5},0).wait(18).to({regX:8.3,scaleX:0.44,scaleY:0.46,skewX:0,skewY:-180,x:183.3,y:164.8},0).wait(2).to({regX:8.4,scaleX:0.44,scaleY:0.46,skewX:3.8,skewY:-177,x:183.4,y:165.5},0).wait(2).to({scaleX:0.44,scaleY:0.46,skewX:7.5,skewY:-173.7,x:183.5,y:166.1},0).wait(2).to({regX:8.6,scaleX:0.45,scaleY:0.46,skewX:11.3,skewY:-170.7,y:166.7},0).wait(2).to({regX:8.3,scaleX:0.45,scaleY:0.45,skewX:15,skewY:-167.4,x:183.6,y:167.4},0).wait(2).to({regY:8.7,scaleX:0.44,scaleY:0.46,skewX:10,skewY:-171.7,x:183.5,y:166.5},0).wait(2).to({regY:8.8,scaleX:0.44,scaleY:0.46,skewX:5,skewY:-176,x:183.4,y:165.7},0).wait(2).to({scaleX:0.44,scaleY:0.46,skewX:0,skewY:-180,x:183.3,y:164.8},0).wait(22).to({scaleX:0.44,scaleY:0.46,skewX:5,skewY:-176,x:183.4,y:165.7},0).wait(2).to({regY:8.7,scaleX:0.44,scaleY:0.46,skewX:10,skewY:-171.7,x:183.5,y:166.5},0).wait(2).to({regY:8.8,scaleX:0.45,scaleY:0.45,skewX:15,skewY:-167.4,x:183.6,y:167.4},0).wait(2).to({regX:8.6,scaleX:0.45,scaleY:0.46,skewX:11.3,skewY:-170.7,x:183.5,y:166.7},0).wait(2).to({regX:8.4,scaleX:0.44,scaleY:0.46,skewX:7.5,skewY:-173.7,y:166.1},0).wait(2).to({scaleX:0.44,scaleY:0.46,skewX:3.8,skewY:-177,x:183.4,y:165.5},0).wait(111).to({regX:9.2,regY:10.9,scaleX:0.44,scaleY:0.46,skewX:0,skewY:-180,x:182.9,y:165.8},0).wait(2).to({y:167.8},0).wait(2).to({y:171.5},0).wait(2).to({y:175.2},0).wait(2).to({skewX:-6.2,skewY:-186.2,x:175.6,y:170.1},0).wait(2).to({regY:11,scaleX:0.44,scaleY:0.48,skewX:-19.9,skewY:-200.9,x:168.2,y:169.1},0).wait(2).to({scaleX:0.45,scaleY:0.49,skewX:-21,skewY:-201.8,x:171.1,y:155.1},0).wait(2).to({regX:9.4,regY:11.2,scaleX:0.46,scaleY:0.5,skewX:-22.2,skewY:-203,x:173.9,y:140.9},0).wait(2).to({regX:9.5,regY:11.1,scaleX:0.46,scaleY:0.49,skewX:-16.6,skewY:-197.1,x:176.1,y:149.5},0).wait(2).to({regX:9.4,regY:11.2,scaleX:0.45,scaleY:0.48,skewX:-11,skewY:-191.3,x:178.4,y:158.1},0).wait(2).to({regX:9.3,scaleX:0.45,scaleY:0.47,skewX:-5.5,skewY:-185.6,x:180.7,y:166.6},0).wait(2).to({regX:9.2,regY:10.9,scaleX:0.44,scaleY:0.46,skewX:0,skewY:-180,x:182.9,y:175.2},0).wait(2).to({y:171.5},0).wait(2).to({y:165.8},0).wait(2).to({regX:8.4,regY:8.8,scaleX:0.44,scaleY:0.46,skewX:3.8,skewY:-177,x:183.4,y:165.5},0).wait(2).to({skewX:18.8,skewY:-162,x:183.3,y:165.6},0).wait(2).to({regX:9.2,regY:10.8,scaleX:0.44,scaleY:0.46,rotation:-15,skewX:0,skewY:0,x:208.8,y:165.8},0).wait(2).to({regY:11,scaleY:0.46,rotation:-9.8,y:168.9},0).wait(2).to({regY:10.8,rotation:-4.8,y:172.1},0).wait(2).to({regY:10.9,scaleY:0.46,rotation:0,y:175.2},0).wait(2).to({rotation:6.2,x:216.2,y:170.1},0).wait(2).to({regY:11,scaleX:0.44,scaleY:0.48,rotation:0,skewX:19.9,skewY:20.9,x:223.5,y:169.1},0).wait(2).to({scaleX:0.45,scaleY:0.49,skewX:21,skewY:21.8,x:220.7,y:155.1},0).wait(2).to({regX:9.8,regY:11.1,scaleX:0.46,scaleY:0.5,skewX:22.2,skewY:23,x:218.1,y:140.9},0).wait(2).to({regX:9.9,regY:11,scaleX:0.46,scaleY:0.49,skewX:16.6,skewY:17.1,x:215.8,y:149.5},0).wait(2).to({regX:10.4,scaleX:0.45,scaleY:0.48,skewX:11,skewY:11.3,x:213.7,y:158.1},0).wait(2).to({regX:9.8,regY:11.2,scaleX:0.45,scaleY:0.47,rotation:5.5,skewX:0,skewY:0,x:211.2,y:166.7},0).wait(2).to({regX:9.2,regY:10.9,scaleX:0.44,scaleY:0.46,rotation:0,x:208.8,y:175.2},0).wait(2).to({y:171.5},0).wait(2).to({y:165.8},0).wait(2).to({regX:8.4,regY:8.8,scaleX:0.44,scaleY:0.46,skewX:-3.8,skewY:-3,x:208.4,y:165.5},0).wait(81));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(161.4,137,66,103.7);


(lib.penguin = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// footGlow
	this.footGlow = new lib.penguin_footGlow();
	this.footGlow.parent = this;
	this.footGlow.setTransform(234.8,216.2,1,1,0,0,0,29.5,8.1);
	this.footGlow.alpha = 0;
	this.footGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.footGlow.cache(-4,-4,67,24);

	this.timeline.addTween(cjs.Tween.get(this.footGlow).wait(1));

	// beakGlow
	this.beakGlow = new lib.penguin_beakGlow();
	this.beakGlow.parent = this;
	this.beakGlow.setTransform(213.8,77.4,1,1,0,0,0,22.1,8.7);
	this.beakGlow.alpha = 0;
	this.beakGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.beakGlow.cache(-4,-4,52,26);

	this.timeline.addTween(cjs.Tween.get(this.beakGlow).wait(1));

	// tummyGlow
	this.tummyGlow = new lib.penguin_tummyGlow();
	this.tummyGlow.parent = this;
	this.tummyGlow.setTransform(237.9,154,1,1,0,0,0,28.6,60.9);
	this.tummyGlow.alpha = 0;
	this.tummyGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.tummyGlow.cache(-4,2,61,114);

	this.timeline.addTween(cjs.Tween.get(this.tummyGlow).wait(1));

	// Layer 5
	this.foot1 = new lib.invisiblebox();
	this.foot1.parent = this;
	this.foot1.setTransform(235.3,216.1,1.615,0.468,4.2);

	this.beak = new lib.invisiblebox();
	this.beak.parent = this;
	this.beak.setTransform(221.4,75.1,1.609,0.512);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(237.2,150.2,1.356,2.345);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.tummy},{t:this.beak},{t:this.foot1}]}).wait(1));

	// main
	this.main = new lib.Penguin();
	this.main.parent = this;
	this.main.setTransform(532.7,-74.9,1.648,1.648,0,0,180,20.5,55.3);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.penguin, new cjs.Rectangle(187.7,59.7,112.8,172.5), null);


// stage content:
(lib.MWpenguin = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.PenguinHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(196.3,158.6,0.469,0.484,0,0,0,26.4,44.7);

	this.instance_1 = new lib.PenguinBelly_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(198.1,223.3,0.323,0.422,0,0,0,53.6,154.1);

	this.instance_2 = new lib.PenguinFeet_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(201.3,231.9,0.407,0.426,0,0,0,44.1,11.4);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,7);

	this.instance_3 = new lib.PenguinHead_001_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(196.3,158.6,0.469,0.484,0,0,0,26.4,44.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(476.3,373.5,20,20);
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWpenguin_atlas_.png?1528313005714", id:"MWpenguin_atlas_"}
	],
	preloads: []
};




})(lib_Penguin = lib_Penguin||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Penguin, images, createjs, ss, AdobeAn;